module.exports = __webpack_public_path__ + "img/logo-lanscape.950cb430.jpg";